export function calculateFinalPrice(basePrice: number, taxRate: number): number {
	const taxAmount = (basePrice * taxRate) / 100;
	return basePrice + taxAmount;
}

export function calculateBaseAmount(finalAmount: number, percentages: number[]): number {
	let divisor = 1;

	percentages.forEach(p => {
		divisor *= 1 + p / 100;
	});

	return finalAmount / divisor;
}

export function calculateAddedAmount(finalAmount: number, percentages: number[], index: number): number {
	let base = calculateBaseAmount(finalAmount, percentages);

	for (let i = 0; i < index; i++) {
		base *= 1 + percentages[i] / 100;
	}

	return base * (percentages[index] / 100);
}
